module.exports = __webpack_public_path__ + "static/media/YF82_1.0c64e6cb.jpg";